import adjacentPositions from '../../../blocks/constants/adjacent-positions';

const { BEFORE_BEGIN } = adjacentPositions;

const getNewNumericPositionBySibling = (adjacentPosition, siblingNumericPosition) =>
  adjacentPosition === BEFORE_BEGIN ? siblingNumericPosition - 1 : siblingNumericPosition + 1;

export default getNewNumericPositionBySibling;
